<template>
  <v-flex class="week-day-box">
    <div v-if="!shift.approved" class="approval-needed-notice grey--text">
      Pending approval
    </div>
    <div :class="shift.approved ? 'approved' : 'pending-approval'">
      <h4 v-if="!user.role.client">
        <div v-if="shift.tradePending && user.role != 'client'">
          <v-tooltip bottom v-if="!shift.tradeApprovalPending">
            <v-icon slot="activator" color="primary"> sync </v-icon>
            <span>Up for Trade</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <v-icon slot="activator" color="warning"> sync </v-icon>
            <span>Trade accepted; pending manager approval</span>
          </v-tooltip>
        </div>
        <router-link
          :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
          target="_blank"
        >
          {{ shift.location }}
        </router-link>
      </h4>
      <div>
        <router-link
          :class="shift.workerName ? 'green--text' : 'red--text'"
          :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
          target="_blank"
        >
          {{ shift.shiftRole }}
        </router-link>
        <span v-if="shift.workerName">
          |
          <EmployeeName
            :name="shift.workerName"
            :employeeId="shift.userId"
            :link="user.clientOrHigher"
          />
        </span>
        <v-tooltip top>
          <v-icon v-if="shift.employeeAbsent" color="warning" slot="activator">
            warning
          </v-icon>
          <span>Employee was absent</span>
        </v-tooltip>
      </div>
      <div>
        {{ shift.startDatetime | moment("h:mma") }} -
        {{ shift.endDatetime | moment("h:mma") }}
      </div>
      <div>
        <BonusView :shift="shift" type="travel" :role="user.role" />
        <BonusView :shift="shift" type="callIn" :role="user.role" />
        <BonusView :shift="shift" type="straight" :role="user.role" />

        <v-tooltip bottom :disabled="!shift.hasDirections">
          <v-icon
            slot="activator"
            :color="shift.hasDirections ? 'blue' : 'grey lighten-2'"
            class="shift-details-icon"
          >
            location_on
          </v-icon>
          <span>Directions Available</span>
        </v-tooltip>
      </div>
    </div>
  </v-flex>
</template>

<script>
export default {
  props: ["shift", "user"]
};
</script>

<style scoped>
.shift-details-icon {
  cursor: default;
}
</style>
